if (!customElements.get('eg-pair-offer')) {
  class EgPairOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.offers = JSON.parse(this.dataset.offers);
      this.variants = JSON.parse(this.dataset.variants);
      this.button = this.querySelector('[data-pair-add]');
      this.status = this.querySelector('[data-pair-status]');
      this.onChange = event => {
        const form = document.getElementById(this.dataset.formId);
        if (form && event.target.name === 'id' && form.contains(event.target)) this.update(event.target.value);
      };
      this.onAdd = () => this.addPair();
      document.addEventListener('change', this.onChange);
      this.button.addEventListener('click', this.onAdd);
      this.update(this.dataset.currentId);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      this.button?.removeEventListener('click', this.onAdd);
      this.initialized = false;
    }
    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale, { style:'currency', currency:this.dataset.currency, minimumFractionDigits:2, maximumFractionDigits:2 }).format(cents / 100);
    }
    update(id) {
      this.variant = this.variants.find(v => String(v.id) === String(id));
      this.quote = this.offers[String(id)];
      const valid = this.variant?.available && this.quote?.unit === this.variant.price && this.quote.single === this.quote.unit && this.quote.discount > 0 && this.quote.pair > 0;
      this.hidden = !valid;
      this.button.disabled = !valid;
      if (!valid) return;
      this.querySelector('[data-pair-title]').textContent = this.dataset.title.replace('__AMOUNT__', this.money(this.quote.pair));
      this.status.textContent = '';
    }
    async addPair() {
      if (this.hidden || this.button.disabled) return;
      this.button.disabled = true;
      this.status.textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:this.variant.id,quantity:2}]}) });
        if (!response.ok) throw new Error('cart-add');
        await response.json();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const drawer = document.querySelector('cart-drawer');
        if (typeof drawer?.open === 'function') drawer.open();
        this.status.textContent = this.dataset.added;
      } catch {
        this.status.textContent = this.dataset.error;
      } finally {
        this.button.disabled = this.hidden;
      }
    }
  }
  customElements.define('eg-pair-offer', EgPairOffer);
}
